/* eslint-disable no-underscore-dangle */
import auth0 from 'auth0-js';
import { clearCacheAuth0Result, clearCacheInstance } from '../../helpers/secureCache';
import { oauthDomain, oauthClientId, oauthType, oauthScope, } from '../../environment.vars';
import { DEVELOPMENT_MODE, EXPIRATION_TOKEN_KEY, TERMS_ACCEPTED_KEY, } from '../../constants/constants';
import { removeCookie } from '../../helpers/utils';
export var appDomain = "".concat(window.location.origin, "/");
export var domain = oauthDomain;
export var clientID = oauthClientId;
export var redirectUri = "".concat(appDomain, "callback");
export * from 'auth0-js';
var Oauth = /** @class */ (function () {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    function Oauth() {
    }
    Oauth.getInstance = function () {
        if (!Oauth._instance) {
            Oauth._instance = new auth0.WebAuth({
                domain: domain,
                clientID: clientID,
                redirectUri: redirectUri,
                responseType: oauthType,
                scope: oauthScope,
            });
        }
        return Oauth._instance;
    };
    Oauth.getAuthResult = function () {
        return new Promise(function (resolve, reject) {
            Oauth.getInstance().parseHash({ hash: window.location.hash }, function (err, authResult) {
                if (err)
                    reject(err);
                else if (!authResult)
                    reject(new Error('invalid auth error'));
                resolve(authResult);
            });
        });
    };
    Oauth.checkSession = function () {
        return new Promise(function (resolve, reject) {
            Oauth.getInstance().checkSession({}, function (err, authResult) {
                if (err) {
                    return reject(err);
                }
                return resolve(authResult);
            });
        });
    };
    Oauth.requestConsent = function () {
        return Oauth.getInstance().authorize({
            prompt: 'consent',
        });
    };
    Oauth.fullAuthorize = function () {
        Oauth.getInstance().authorize({ prompt: 'login' });
    };
    Oauth.logout = function (returnTo) {
        if (returnTo === void 0) { returnTo = appDomain; }
        if (DEVELOPMENT_MODE) {
            clearCacheInstance();
        }
        clearCacheAuth0Result();
        removeCookie(TERMS_ACCEPTED_KEY);
        removeCookie(EXPIRATION_TOKEN_KEY);
        sessionStorage.clear();
        Oauth.getInstance().logout({
            returnTo: returnTo,
            clientID: clientID,
        });
    };
    return Oauth;
}());
export default Oauth;
//# sourceMappingURL=Auth0Provider.js.map